import { useLocation } from 'react-router-dom';
import { EXCEL_CONFIRM_ROUTE_MAP } from './excelPolicyByRoute.js';

const useExcelConfirmYn = () => {
    const { pathname } = useLocation();
    return EXCEL_CONFIRM_ROUTE_MAP[pathname] ?? false;
};

export default useExcelConfirmYn;